var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download_page",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toDownloadApp($event)}}},[_c('img',{attrs:{"src":require("@/assets/img/spread/page.png"),"alt":"download"}})])}
var staticRenderFns = []

export { render, staticRenderFns }